<template>
<div>
<header v-if="this.flag == true" class="main-header">
    <h1 class="header-logo">
      <router-link to="/dashboard">
        <a><img src="../../public/img/header-tfc-logo.png" alt="TFabConnect β"></a>
      </router-link>
    </h1>
    <div class="header-info-area">
        <div class="select-language">
        <ul class="language-list">
            <li v-bind:class="{active: isJapanese}"><a @click="setLocale(`ja`)">日本語</a></li>
            <li v-bind:class="{active: isEnglish}"><a @click="setLocale(`en`)">English</a></li>
        </ul>
        </div>
        <div v-if="initialized" class="user-icon">
          <a @click="mypage.active = true"><i class="fas fa-user"></i>{{myname}}</a>
        </div>
    </div>
    <b-modal :active.sync="mypage.active" has-modal-card custom-class="popup-wrapper" scroll="keep">
      <div class="popup-content">
        <div class="popup-title">
          <h3><i class="fas fa-user"></i>{{$t('app.header.user.user_info')}}</h3>
          <div class="level">
            <h4 class="level-item">ID:</h4>
            <div class="level-item"></div>
            <p class="level-item">{{myId}}</p>
          </div>
        </div>
        <font size="3">{{$t('app.header.user.user_name')}}</font>
        <div class="input-box">
          <b-input ref="target" custom-class="input-rename" :pattern="pattern" v-model="mypage.newname" maxlength="16" required></b-input>
          <button :disabled="!validation" @click="rename()"><i class="fas fa-save"></i>{{$t('app.header.user.save')}}</button>
        </div>
        <font size="1">{{$t('app.dashboard.validation_message')}}</font>

        <!-- <div class="input-box"><input type="text" name="" placeholder="ユーザー名"><button><i class="fas fa-save"></i>保存</button></div> -->
        <ul class="user-info-menu">
          <li v-if="loggedIn">
            <button class="sns-logined-btn"><i class="fas fa-check-circle"></i>{{$t('app.header.user.sns_logined')}}</button>
          </li>
          <li v-else>
            <button @click="redirectToLogin" class="sns-login-btn"><i class="fas fa-check-circle"></i>{{$t('app.header.user.sns_login')}}</button>
            <div class="sns-login-message">
              <p>{{$t('app.header.user.warn')}}</p>
            </div>
          </li>
          <li><button v-if="loggedIn" class="log-out-btn" @click="loginButtonClick()"><i class="fas fa-sign-out-alt"></i>{{$t('app.header.user.logout')}}</button></li>
          <li><button class="delete-btn" @click="onConfirmDelete()"><i class="fas fa-user-slash"></i>{{$t('app.header.user.delete')}}</button></li>
        </ul>
        <Coupon :loggedIn="loggedIn" />
      </div>
    </b-modal>
    <b-loading :is-full-page="isFullPage" :active.sync="isLoading" :can-cancel="false"></b-loading>
</header>

<header v-else class="main-header">
    <h1 class="header-logo">
      <router-link to="/dashboard">
        <a><img src="../../public/img/header-tfc-logo.png" alt="TFabConnect β"></a>
      </router-link>
    </h1>
    <div class="header-info-area">
        <div class="select-language">
        <ul class="language-list">
            <li v-bind:class="{active: isJapanese}"><a @click="setLocale(`ja`)">日本語</a></li>
            <li v-bind:class="{active: isEnglish}"><a @click="setLocale(`en`)">English</a></li>
        </ul>
        </div>
    </div>
</header>
</div>
</template>
<script>
const queryString = require('query-string');
import {mapState, mapGetters, mapActions} from 'vuex'
import Coupon from './view/Coupon'

export default {
  components: {
    Coupon
  },
  data() {
    return {
      mypage: {
        active: false,
        newname: ""
      },
      isLoading: false,
      isFirefox: window.navigator.userAgent.includes("Firefox"),
      pattern: this.isFirefox? "^[A-Za-z0-9-_@\\/][A-Za-z0-9-_@ \\/]*$" : "^[0-9-_@\\/\\p{General_Category=Letter}\\p{Emoji}][0-9-_@ \\/\\p{General_Category=Letter}\\p{Emoji}]*$", // 先頭文字はSpace除く
      origin_url: null,
      flag: this.$store.state.dashboard.options.userflag
    }
  },
  computed: {
    validation: function() {
        return RegExp(this.pattern, "u").test(this.mypage.newname)
    },
    loggedIn() {
      return this.$store.getters["account/authenticated"]
    },
    ...mapState({
      myname: state => state.account.name,
      myId: state => state.account.id
    }),
    ...mapGetters({
      initialized: 'account/initialized',
      isJapanese: 'preferences/isJapanese',
      isEnglish: 'preferences/isEnglish'
    })
  },
  mounted() {
    this.$store.subscribe(mutation => {
      if ( mutation.type === "UpdateUserFlag" ) {
        this.flag = this.$store.state.dashboard.options.userflag
      }
    })
    if (this.myname) {
        this.mypage.newname = this.myname
    }
    this.$store.watch(state => state.groups.selected, () => {
        this.mypage.newname = this.myname
    });
  },
  /*
  watch: {
    mypage: {
      handler: function () {
        if(this.mypage.active == true){
          this.t_focus()
        }
      },
      deep: true
    }
  },
  */
  methods: {
    /* 
    t_focus(){
      this.$nextTick(() => this.$refs.target.focus())
    },
    */
    loginButtonClick() {
      if (this.loggedIn) {
        if(this.$store.state.preferences.locale == "ja"){
          this.origin_url = location.origin
        }else{
          this.origin_url = location.origin + "/en"
        }
        this.$store.dispatch('account/logout_tmp')
        .then(() => location.href = this.origin_url)
      } else {
        this.$router.push('/login', () => {})
      }
    },
    redirectToLogin() {
        this.$store.commit('preferences/setPreferences', {isWelcome: 'false'})
        const hostname = 'auth.tfabconnect.com'
        const pathname = '/login'
        const query = {
            'client_id': '1nsderidh969374vl5mvitinhs',
            'response_type': 'code',
            'scope': 'phone+email+openid+profile',
            'redirect_uri': `${location.protocol}//${location.host}/dashboard/`
        }
        location.href = `https://${hostname}${pathname}?${queryString.stringify(query, {encode: false})}`
      },
    onConfirmDelete() {
      this.$buefy.dialog.confirm({
        title: this.$t("app.header.withdraw.title"),
        message: this.$t("app.header.withdraw.message"),
        confirmText: this.$t("app.header.withdraw.confirm"),
        cancelText: this.$t("app.header.withdraw.cancel"),
        type: 'is-danger',
        hasIcon: true,
        onConfirm: async () => {
          this.isLoading = true
          if(this.$store.state.preferences.locale == "ja"){
            this.origin_url = location.origin
          }else{
            this.origin_url = location.origin + "/en"
          }
          await this.deleteUser()
          this.$store.dispatch('account/logout')
          .then(() => location.href = this.origin_url)
          .catch(() => { 
            this.$buefy.toast.open({
              duration: 7000,
              message: this.$t('app.dashboard.graph.error_warning'),
              position: "is-top",
              type: "is-danger"
            })
            return Promise.resolve()
          })
          .finally(() => this.isLoading = false)
        }
      })
    },
    setLocale(locale) {
      this.$store.commit('preferences/setPreferences', {locale: locale})
      location.reload()
    },
    rename() {
      this.isLoading = true
      this.modifyUser(this.mypage.newname)
      .then(() => location.reload())
      .then(() => this.$buefy.toast.open({
        duration: 2000,
        message: this.$t("app.header.user.success"),
        position: "is-top",
        type: "is-success"
      }))
      .catch(() => {
        this.$buefy.toast.open({
          duration: 7000,
          message: this.$t('app.dashboard.graph.error_warning'),
          position: "is-top",
          type: "is-danger"
        })
        return Promise.resolve()
      })
      .finally(() => this.isLoading = false)
    },
    ...mapActions({
      modifyUser: 'account/modifyUser',
      deleteUser: 'account/deleteUser',
      UpdateUserFlag: 'dashboard/UpdateUserFlag'
    })
  },
}
</script>
<style scoped>
.main-header {
  position: relative;
  width: 100%;
  height: 50px;
  background: #333;
}

.header-logo {
  position: absolute;
  top: 50%;
  left: 5px;
  transform: translateY(-50%);
  width: 250px;
}

@media (max-width: 485px) {
  .header-logo {
      max-width: calc(100% - 210px);
  }
}

.header-logo img {
  display: block;
}

.header-info-area {
  display: flex;
  align-items: center;
  position: absolute;
  top: 0;
  right: 0;
  height: 50px;
}
@media (max-width: 485px) {
  .header-info-area {
    max-width: 210px;
    font-size: .8rem;
    padding-left: 20px;
    padding-right: 10px;
  }
}

.header-info-area .select-language {
  padding: 0 20px;
}
@media (max-width: 485px) {
  .header-info-area .select-language {
    padding: 0;
  }
}
.header-info-area .select-language .language-list {
  display: flex;
}
.header-info-area .select-language .language-list li {
  width: 100px;
}
@media (max-width: 485px) {
  .header-info-area .select-language .language-list li {
    width: 90px;
  }
}
.header-info-area .select-language .language-list li a {
  display: block;
  padding: 0 15px;
  height: 30px;
  line-height: 30px;
  white-space: nowrap;
  background: #e9e9e9;
  text-decoration: none;
  color: #999;
  font-weight: bold;
  text-align: center;
}
@media (max-width: 485px) {
  .header-info-area .select-language .language-list li a {
    padding: 0 5px;
  }
}
.header-info-area .select-language .language-list li:nth-of-type(1) a {
  border-radius: 4px 0 0 4px;
}
.header-info-area .select-language .language-list li:nth-of-type(2) a {
  border-radius: 0 4px 4px 0;
}
.header-info-area .select-language .language-list li.active a {
  background: #2c6ac4;
  color: #fff;
}
.header-info-area .select-language select {
  font-size: 0.875rem;
  border: 1px solid #ddd;
}
.header-info-area .user-icon {
  height: 50px;
  line-height: 50px;
  border-left: 1px solid #666;
  color: #fff;
}
.header-info-area .user-icon a {
  display: block;
  padding: 0 20px;
  height: 100%;
  color: #fff;
  text-decoration: none;
}
.header-info-area .user-icon a i {
  vertical-align: baseline;
  margin-right: 10px;
  font-size: 1.125rem;
}
.header-info-area .login-btn {
  width: 50px;
  height: 100%;
  border-left: 1px solid #666;
}
.header-info-area .login-btn a {
  display: block;
  position: relative;
  height: 100%;
  color: #fff;
}
.header-info-area .login-btn a i {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  font-size: 1.125rem;
}
.userpage {
  min-width: 470px;
}

.popup-title {
  width: 100%;
  padding-bottom: 10px;
  margin-bottom: 20px;
  border-bottom: 1px solid #ccc;
}
.popup-title h3 {
  font-size: 1.25rem;
  font-weight: bold;
  letter-spacing: .05em;
  margin-bottom: 10px;
}
.popup-title i {
  margin-right: .0.3125rem;
}
.popup-content .popup-close-btn {
  position: absolute;
  top: 15px;
  right: 15px;
}

.user-info-menu {
  margin-top: 20px;
}
.user-info-menu li {
  margin-bottom: 10px;
}
.user-info-menu li button {
  position: relative;
  width: 100%;
  height: 40px;
  padding: 0 20px 0 50px;
  border-radius: 4px;
  font-size: 0.9375rem;
  cursor: pointer;
  color: #fff;
  text-align: left;
}
.user-info-menu li button i {
  position: absolute;
  left: 15px;
  font-size: 1.125rem;
  top: 50%;
  transform: translateY(-50%);
}
.user-info-menu li button.sns-login-btn {
  background: #4caf50;
}
.user-info-menu li button.sns-logined-btn {
  background: #4caf50;
  cursor: default;
}
.user-info-menu li button.delete-btn {
  background: red;
}
.user-info-menu li button.log-out-btn {
  background: #888;
}
.sns-login-message {
  background: #b3ecc7;
  width: 100%;
  height: 60px;
  padding: 10px;
  text-align: center;
  display: table-cell;
  vertical-align: middle;
}
.input-box {
  display: flex;
  justify-content: space-between;
}
.input-box div {
  /*width: 90%;*/
  width: calc(100% - 5px);
  height: 40px;
  padding: 0 0px;
  font-size: 0.9375rem;
  border: 0px solid #ccc;
  border-radius: 4px;
}
.input-box button {
  width: 100px;
  height: 40px;
  padding: 0 10px;
  background: #f5f5f5;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 0.9375rem;
  cursor: pointer;
}
.input-box button i {
  margin-right: .3em;
}
.input-box button:hover {
  opacity: .7;
}
</style>

<style>
.popup-wrapper .modal-background {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 10;
}
.popup-wrapper .animation-content {
  width: 500px;
  display: block;
  position: fixed;
  padding: 30px;
  z-index: 20;
  background: #fff;
  top: 70px;
  right: 20px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.4);
}
.popup-wrapper .animation-content:before {
  display: block;
  position: absolute;
  top: -30px;
  right: 25px;
  content: "";
  border-top: 15px solid transparent;
  border-left: 15px solid transparent;
  border-right: 15px solid transparent;
  border-bottom: 15px solid #fff;
}
.popup-wrapper .popup-content .input-box button{
  height: 36px;
}
.popup-wrapper .animation-content .confirm-modal .animation-content{
  width: 550px;
  position: static;
  padding: 0px;
  z-index: 10;
}
</style>
